import { clearAccessToken, signOut, useAuth } from '../auth'
import { clearSessionCookies } from '../auth/sessionCookies'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Logout() {
  const navigate = useNavigate()
  const { clearAuth } = useAuth()

  useEffect(() => {
    const run = async () => {
      await signOut()

      clearSessionCookies()
      clearAccessToken()
      clearAuth()
      localStorage.removeItem('collapsedState')
      navigate('/?logout=true', { replace: true })
    }

    run()
  }, [navigate, clearAuth])

  return <p style={{ padding: 20 }}>Cerrando sesión...</p>
}
